import styled, { StyledComponent } from 'styled-components';

export const ManagementTableWrapper: StyledComponent<'div', any> = styled.div`
  height: calc(-193px + 100vh);
  width: 100%;
  padding: 0 16px;
`;

export const BaseTableWrapper: StyledComponent<'div', any> = styled.div`
  height: calc(100% - 44px);
  width: 100%;

  .BaseTable__row {
    transition: all 0.3s ease-in-out;
    transform: translateY(0px);
    position: relative;
    z-index: 1;
  }

  .BaseTable__row:hover,
  .BaseTable__row--hovered {
    background-color: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 2;
  }
`;
